var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4986_5755",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4986_5755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.06248 16.25V15.4167H5.72915V10.9583L1.77081 5H10.5416L6.56248 10.9583V15.4167H8.22915V16.25H4.06248ZM4.39581 7.5H7.89581L9.04165 5.83333H3.27081L4.39581 7.5ZM12.8125 16.25C12.243 16.25 11.7536 16.0486 11.3441 15.6458C10.9341 15.2431 10.7291 14.75 10.7291 14.1667C10.7291 13.5833 10.9341 13.0903 11.3441 12.6875C11.7536 12.2847 12.243 12.0833 12.8125 12.0833C13.0347 12.0833 13.2464 12.1214 13.4475 12.1975C13.6491 12.2742 13.8541 12.3958 14.0625 12.5625V5H17.3958V6.47917H14.8958V14.1667C14.8958 14.75 14.6944 15.2431 14.2916 15.6458C13.8889 16.0486 13.3958 16.25 12.8125 16.25Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/Bar.ce35fad7146af3528ac0705ca4a248d4.svg";
export { ForwardRef as ReactComponent };